/* eslint-disable no-nested-ternary */
import type { IndicatorSelection } from "components/financials/modern/types";
import classNames from "components/ui/classNames";
import countBy from "lodash/countBy";
import identity from "lodash/identity";

interface SelectionUniqueRangeValuesProps {
  top?: number;

  selection: IndicatorSelection[];
}
export default function SelectionUniqueRangeValues({ top = 3, selection }: SelectionUniqueRangeValuesProps) {
  const resolvedValues = selection.map(({ value }) => {
    return value.__typename === "FinancialIndicatorSeriesTextNode" ? value.formattedValue : "";
  });

  return (
    <div
      className={classNames(
        "flex w-full max-w-sm space-x-6 overflow-hidden rounded-xl border border-slate-200 bg-slate-50",
        "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
      )}
    >
      <table className="table w-full border-collapse font-mono text-xs">
        <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
          {Object.entries(countBy(resolvedValues, identity))
            .slice(0, top)
            .sort((a, b) => {
              return b[1] - a[1];
            })
            .map(([value, totalCount]) => (
              <tr key={value} className="divide-x divide-slate-200 dark:divide-slate-800">
                <td className="max-w-xs p-2">{value}</td>
                <td className="max-w-xs p-2 font-bold">{totalCount}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
